import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserType } from '../../../../../../../models/user';

export interface Party {
  // Present on party-search results (GET /parties); absent where a Party is built from a
  // number/name pair that was never looked up by id (e.g. PartiesTableComponent.mainParty(),
  // still Number-keyed end-to-end on the Users side). It is what the support-contact endpoints
  // key assignments on (`assignments[].partyId`) — see AssignableParty/isAssignable in the
  // add-department-contact feature, which narrows a Party to one that carries it.
  id?: number;
  number: string;
  name: string;
}

export type PartyFormGroup = FormGroup<{
  number: FormControl<string>;
  name: FormControl<string>;
}>;

export const createUserDetailsForm = () =>
  new FormGroup({
    id: new FormControl('', { nonNullable: true }),
    firstName: new FormControl('', {
      validators: [Validators.required],
      nonNullable: true
    }),
    lastName: new FormControl('', {
      validators: [Validators.required],
      nonNullable: true
    }),
    email: new FormControl('', {
      validators: [Validators.required, Validators.email],
      nonNullable: true
    }),
    userType: new FormControl<UserType>({ value: 'External', disabled: true }, { nonNullable: true }),
    mainPartyName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    mainPartyNumber: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    portalAccess: new FormControl(true, { nonNullable: true }),
    modules: new FormControl<string[]>([], { nonNullable: true }),
    shipmentDocumentCategories: new FormControl<string[]>([], { nonNullable: true }),
    permissions: new FormControl<string[]>([], { nonNullable: true }),
    canAccessAllCustomers: new FormControl<boolean>(false, { nonNullable: true }),
    canAccessAllInvoices: new FormControl<boolean>(false, { nonNullable: true }),
    shipmentsAccess: new FormArray<PartyFormGroup>([]),
    invoicesAccess: new FormArray<PartyFormGroup>([])
  });
